import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Collapse } from 'reactstrap';

import { VIEWS } from '../../helpers/constants';
import CompanyMarketAppList from '../CompanyMarketAppList/CompanyMarketAppList';
import { getRetailAppsList, getRetailPackageList } from '../../actions/retailActions';
import {closeAlert} from '../../actions/commonsActions';
import {I18n} from '../../I18n/components/singlePackage';

import './single-package.css';

class SinglePackage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: '',
			isOpen: false
		}
	}

	toggle = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	};

	onEntering = () => {
		this.setState({ status: 'Opening...' });
	};

	onEntered = () => {
		this.setState({ status: 'Opened' });
	};

	onExiting = () => {
		this.setState({ status: 'Closing...' });
	};

	onExited = () => {
		this.setState({ status: 'Closed' });
	};

	getRetailAllApps = page => {
		const {filter} = this.props;
		return this.props.getRetailAppsList({
			companyId: this.props.company.id,
			page,
			filter: filter ? filter : null
		})
	};

	getRetailPackageAllApps = page => {
		const {filter} = this.props;
		return this.props.getRetailPackageList({
			packageId: this.props.packageItem.id,
			page,
			filter: filter ? filter : null
		})
	};

	render() {
		const { packageItem, globalView, packageApps, lang } = this.props;
		if  (globalView === VIEWS.PACKAGE_ONLY) {
			return (
				<section className="single-package">
					<div className="single-package__top">
						<div className="single-package__title" style={{ marginBottom: '1rem' }}>
						<h5>
							{
								packageItem.name !== `${I18n[lang].all}` ? (
									`${I18n[lang].pack} ${packageItem.name}`
								) : packageItem.name
							}
						</h5>
						{
							packageItem.name !== `${I18n[lang].all}` ? (
								<span className="single-package__total">
									{packageItem.retailMarketItems ? `(${I18n[lang].total}: ` : ""}
									<span className="single-package__total-number">
										{packageItem.retailMarketItems ? ` ${packageItem.retailMarketItems.totalElements})` : ""}
									</span>
								</span>
							) : ""
						}
						</div>
						<div className="single-package__icons">
							<i
								className="package__icon package__set-icon ti-settings"
								onClick={this.props.showAttributes(packageItem)}
								title="Attributes"
							></i>
							<i
								className="package__icon package__del-icon ti-trash"
								title="Delete"
								onClick={ event => {
									event.stopPropagation();
									this.props.remove(packageItem.id)
								}}
							></i>
						</div>
					</div>
				</section>
			)
		}
		return (
			<section className="single-package">
				<div className="single-package__top">
					<div
						className="single-package__title"
						onClick={this.toggle}
						style={{ marginBottom: '1rem' }}
					>
						<h5>
							{
								packageItem.name !== `${I18n[lang].all}` ? (
									`${I18n[lang].pack} ${packageItem.name}`
								) : packageItem.name
							}
						</h5>
                        <span className="single-package__total">
                            {packageItem.total || packageItem.retailMarketItems ? `(${I18n[lang].total}: ` : ''}
							<span className="single-package__total-number">
								{packageItem.total || packageItem.total === 0 ?
									`${packageItem.total})` : packageItem.retailMarketItems ? `${packageItem.retailMarketItems.length})` : ''}
							</span>
						</span>
						{
							this.state.isOpen ?
								<i className="fas fa-arrow-alt-circle-down icon"></i> :
								<i className="fas fa-arrow-alt-circle-right icon"></i>
						}
					</div>
					{
						packageItem.name !== `${I18n[lang].all}` ?
						(
							<div className="single-package__icons">
								<i
									className="package__icon package__set-icon ti-settings"
									onClick={this.props.showAttributes(packageItem)}
									title="Attributes"
								></i>
								<i
									className="package__icon package__del-icon ti-trash"
									title="Delete"
									onClick={ event => {
										event.stopPropagation();
										this.props.remove(packageItem.id)
									}}
								></i>
							</div>
						) :
							""
					}
				</div>
				<Collapse
					className="single-package__wrapper"
					isOpen={this.state.isOpen}
					onEntering={this.onEntering}
					onEntered={this.onEntered}
					onExiting={this.onExiting}
					onExited={this.onExited}
				>
					{
						this.state.isOpen ? (
							<CompanyMarketAppList
								showApp={this.props.showApp}
								getApps={this.props.globalView === VIEWS.ALL ? this.getRetailAllApps : this.getRetailPackageAllApps}
								filter={this.props.filter}
								id={packageItem.id}
							/>
						) : ""
					}
				</Collapse>
			</section>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		getRetailAppsList: query => dispatch(getRetailAppsList(query)),
		getRetailPackageList: (query) => dispatch(getRetailPackageList(query)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
	packageApps: state.retailPackageAppsList.packageApps,
	packagePagination: state.retailPackageAppsList.pagination,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(SinglePackage)



// WEBPACK FOOTER //
// ./src/components/SinglePackage/SinglePackage.js